var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Proximo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_713_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1185_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54FEBD",
    d: "M55,60H11l1.43189-5.7276C12.76579,52.9369,13.96569,52,15.34229,52h35.3154 c1.3766,0,2.5765,0.9369,2.9104,2.2724L55,60z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_901_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54FEBD",
    d: "M34,35c-3.85941,0-7-3.1401-7-7s3.14059-7,7-7c3.85939,0,7,3.1401,7,7S37.85939,35,34,35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_900_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#54FEBD",
    points: "15,30 4,30 7,26 4,22 15,22 18,26  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_321_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M54.01953,64C54.01563,64.00098,54.00781,64,54,64H10c-0.30762,0-0.59863-0.1416-0.78809-0.38477 c-0.18945-0.24219-0.25684-0.55859-0.18164-0.85742l1.43164-5.72754C10.90723,55.24609,12.50391,54,14.34277,54h35.31445 c1.83887,0,3.43555,1.24609,3.88086,3.03027l1.38574,5.54102c0.06152,0.12988,0.0957,0.27539,0.0957,0.42871 C55.01953,63.55273,54.57227,64,54.01953,64z M11.28027,62h41.43945l-1.12109-4.48535C51.375,56.62305,50.57715,56,49.65723,56 H14.34277c-0.91992,0-1.71777,0.62305-1.94141,1.51465L11.28027,62z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_361_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,52C19.15723,52,8.3623,42.81445,6.33301,30.1582c-0.08789-0.54492,0.2832-1.05859,0.8291-1.14551 c0.5459-0.09277,1.05762,0.2832,1.14551,0.8291C10.18066,41.52246,20.14551,50,32,50c13.2334,0,24-10.7666,24-24S45.2334,2,32,2 C20.14551,2,10.18066,10.47754,8.30762,22.1582c-0.08789,0.5459-0.59961,0.91504-1.14551,0.8291 c-0.5459-0.08691-0.91699-0.60059-0.8291-1.14551C8.3623,9.18555,19.15723,0,32,0c14.33691,0,26,11.66309,26,26S46.33691,52,32,52 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_360_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,46c-10.02832,0-18.55371-7.49023-19.83203-17.42188c-0.07031-0.54785,0.31641-1.04883,0.86426-1.12012 c0.5625-0.0625,1.0498,0.31836,1.12012,0.86426C15.30176,37.25977,22.97461,44,32,44c9.9248,0,18-8.0752,18-18S41.9248,8,32,8 c-9.02539,0-16.69824,6.74023-17.84766,15.67773c-0.07031,0.54688-0.55566,0.92871-1.12012,0.86426 c-0.54785-0.07129-0.93457-0.57227-0.86426-1.12012C13.44629,13.49023,21.97168,6,32,6c11.02832,0,20,8.97168,20,20 S43.02832,46,32,46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_331_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,40c-7.71973,0-14-6.28027-14-14s6.28027-14,14-14s14,6.28027,14,14S39.71973,40,32,40z M32,14 c-6.61719,0-12,5.38281-12,12s5.38281,12,12,12s12-5.38281,12-12S38.61719,14,32,14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_342_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,34c-4.41113,0-8-3.58887-8-8s3.58887-8,8-8s8,3.58887,8,8S36.41113,34,32,34z M32,20 c-3.30859,0-6,2.69141-6,6s2.69141,6,6,6s6-2.69141,6-6S35.30859,20,32,20z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_348_"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#1D1B4C",
    cx: 32,
    cy: 26,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_349_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M44,56c-0.55273,0-1-0.44727-1-1v-7.07031c0-0.55273,0.44727-1,1-1s1,0.44727,1,1V55 C45,55.55273,44.55273,56,44,56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_343_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M40,56c-0.55273,0-1-0.44727-1-1v-5.30957c0-0.55273,0.44727-1,1-1s1,0.44727,1,1V55 C41,55.55273,40.55273,56,40,56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_355_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M24,56c-0.55273,0-1-0.44727-1-1v-5.30957c0-0.55273,0.44727-1,1-1s1,0.44727,1,1V55 C25,55.55273,24.55273,56,24,56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_344_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M20,56c-0.55273,0-1-0.44727-1-1v-7.07031c0-0.55273,0.44727-1,1-1s1,0.44727,1,1V55 C21,55.55273,20.55273,56,20,56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_323_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M12,31H1c-0.37891,0-0.72461-0.21387-0.89453-0.55273c-0.16895-0.33887-0.13281-0.74414,0.09473-1.04688 L2.75,26l-2.5498-3.40039c-0.22754-0.30273-0.26367-0.70801-0.09473-1.04688C0.27539,21.21387,0.62109,21,1,21h11 c0.31445,0,0.61133,0.14844,0.7998,0.40039l3,4c0.2666,0.35547,0.2666,0.84375,0,1.19922l-3,4 C12.61133,30.85156,12.31445,31,12,31z M3,29h8.5l2.25-3l-2.25-3H3l1.7998,2.40039c0.2666,0.35547,0.2666,0.84375,0,1.19922L3,29z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_356_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,27H15c-0.55273,0-1-0.44727-1-1s0.44727-1,1-1h17c0.55273,0,1,0.44727,1,1S32.55273,27,32,27z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_322_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M48,60H16c-0.55273,0-1-0.44727-1-1s0.44727-1,1-1h32c0.55273,0,1,0.44727,1,1S48.55273,60,48,60z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.ee954608af8faa461b70de22d7ba6b8e.svg";
export { ForwardRef as ReactComponent };